// extracted by mini-css-extract-plugin
export var numpadContainer = "_se-1";
export var phoneButton = "_se-0";